// Production team gate for Document Smart Text.
// Dev / preview / PR-preview deploys / test: feature is always on.
// Production (app.easil.com): only the pilot teams below get the feature.
// Remove this file (and the two consumer-import lines) once the feature
// is fully rolled out — see specs/2026-05-27-feature-document-smart-text-team-gate.md.
export const DOCUMENT_SMART_TEXT_ALLOWED_TEAM_IDS: ReadonlySet<string> =
  new Set([
    "c9e3e516-3546-4e6b-bcdb-a2f307fde368", // Brumbys
    "1463f1d0-4d8f-43e4-9444-0c088ddd7826", // Gloria Jeans
    "b0e41774-54f7-4188-8b38-0cc17ce36bc7" // Silk Lazer
  ]);

const PRODUCTION_HOSTNAME = "app.easil.com";

// Mirrors sessionRecorder.js#isProductionEnvironment so PR preview deploys
// (pr*-dev.easil.com), dev.easil.com, and the editor embedded in CopyMaker
// iframes are all treated as "not production" — the production build flag
// alone isn't enough, since PR previews are also production builds.
const getHostname = (): string => {
  if (typeof window === "undefined") return "";
  try {
    if (window.location !== window.parent.location) {
      return window.parent.location.hostname;
    }
  } catch {
    // Cross-origin parent throws SecurityError — fall through to own hostname.
  }
  return window.location.hostname;
};

const isProductionEnvironment = (): boolean =>
  process.env.NODE_ENV === "production" &&
  getHostname() === PRODUCTION_HOSTNAME;

export const isDocumentSmartTextAllowedForTeam = (
  teamId: string | null | undefined
): boolean => {
  if (!isProductionEnvironment()) return true;
  if (!teamId) return false;
  return DOCUMENT_SMART_TEXT_ALLOWED_TEAM_IDS.has(teamId);
};
